import type { AccordionStylesType } from '@material-tailwind/react';

const styles: AccordionStylesType = {
  styles: {
    base: {
      container: {
        border:
          'border-t border-blue-100 sm:border sm:rounded-2xl sm:border-blue-100',
        spacings: 'pt-4 sm:p-4',
      },
      header: {
        initial: {
          border: 'border-none',
          cursor: 'cursor-pointer',
          spacings: 'py-0',
        },
      },
    },
  },
};

export default styles;
